<template>
  <div class="stat-trend stat-block pt-4 pb-3" v-if="loaded">
    <div class="container">

      <div class="row">
        <div class="col-6">
          <h4 class="pb-1">Spotpriser</h4>

          <div class="row">
            <trend-block v-for="scale in scales" :key="scale.handle" :scale="scale" type="spot" />
          </div>

        </div>
        <div class="col-6">
          <h4 class="pb-1">Marknadspriser</h4>

          <div class="row">
            <trend-block v-for="scale in scales.filter(scale => scale.handle !== 'year')" :key="scale.handle" :scale="scale" type="market" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import {mapState} from "vuex"
  import {areaCategories, contractTypes, statisticsScales} from "./../../../../../app/services/Data/GeneralData"
  import StatLoader from "../../Partials/Loader"
  import DateMixin from "../../../../../app/mixins/helpers/DateMixin"
  import TrendBlock from "./Trend/Block"

  export default {
    name: "StatPricesTrend",
    components: {TrendBlock, StatLoader},
    mixins: [
      DateMixin
    ],
    computed: {
      ...mapState({
        loaded: state => state.statistics.prices.trend.loaded,
        trends: state => state.statistics.prices.trend.data,
      }),
      scales() {
        return [
          {handle: 'week', name: 'Vecka'},
          {handle: 'month', name: 'Månad'},
          {handle: 'year', name: 'År'},
        ]
      }
    },
    async mounted() {
      const input = {
        types: ['spot', 'market'],
      }

      await this.$store.dispatch('statistics/trend', input)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Market/Prices/Trend.vue